import type { AnalyzedSolanaTransaction } from '@pkg/solana'
import { analyzeSolanaTransaction as analyzeTransaction } from '@pkg/solana'
import type { AnalyzeSolanaTransactionParameters } from './types'

export const analyzeSolanaTransaction = async ({
  transaction,
  tokenAccountOwnerMap,
  splTokenDatasource,
  jsonDatasource,
  accountIds,
}: AnalyzeSolanaTransactionParameters): Promise<AnalyzedSolanaTransaction> => {
  const analyzedTransaction = await analyzeTransaction({
    transaction,
    tokenAccountOwnerMap,
    splTokenDatasource,
    jsonDatasource,
    accountIds,
  })
  return analyzedTransaction
}
